import { takeLatest, put, call } from 'redux-saga/effects';
import { loginSuccess, loginFail, 
    logoutSuccess, logoutFail, 
    getAuthUserSuccess, getAuthUserFail,
    getAuthUserModuleSuccess, getAuthUserModuleFail
 } from './authState';
import authservice from '../../services/authservice';
import { showLoading, hideLoading } from '../layout/layoutState';

function* loginUser(action) {
  	try {
    
    	yield put(showLoading('Authenticating...'));
    	const { username, password } = action.payload;
    	const authToken = yield call(authservice.login, username, password); 

    	if(authToken){	
      		yield put(loginSuccess(authToken));
      		
			yield put({ type: 'auth/getAuthUser' });
			
			yield put({ type: 'auth/getAuthUserModule' });
			
	      	/*try {
				  console.log('test 3');
	        	const user = yield call(authservice.getCurrentUser);
	        	console.log('test 4'); 
	        	yield put(getAuthUserSuccess(user));
				console.log('test 5');
	      	} catch (error) {
				  console.log(error.message);
	          	yield put(getAuthUserFail(error.message));
	      	}finally{
				yield put(hideLoading());
		  	}*/
    	}

  	} catch (error) {
    	console.log(error.message);
    	yield put(loginFail(error.message));
  	}finally{
		yield put(hideLoading());
  	}
}

function* logoutUser(action) {
	yield put(showLoading('Logging out...'));
    try {
      
      	const authToken = yield call(authservice.logout); 
      	yield put(logoutSuccess(authToken));
  		
    } catch (error) {
      	yield put(logoutFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
  }

function* getAuthUser(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUser); 
        yield put(getAuthUserSuccess(user));

    } catch (error) {
        yield put(getAuthUserFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* getAuthUserModule(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUserModules); 
        yield put(getAuthUserModuleSuccess(user));

    } catch (error) {
        yield put(getAuthUserModuleFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* authSaga() {
  	yield takeLatest('auth/loginRequest', loginUser);
  	yield takeLatest('auth/logoutRequest', logoutUser);
  	yield takeLatest('auth/getAuthUser', getAuthUser);
  	yield takeLatest('auth/getAuthUserModule', getAuthUserModule);
}

export default authSaga;
